import React from 'react';

import { Asset, Wrapper } from './styles';

interface Props {
    minHeight?: number;
}

export const LoadingCard = ({ minHeight }: Props) => {
    return (
        <Wrapper $minHeight={minHeight}>
            <Asset />
        </Wrapper>
    );
};
